import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import AbundanceViewPanelTrigger from '../../../../abundanceEngine/AbundanceViewPanel/AbundanceViewPanelTrigger'
import OpalTag from '../../../opal/OpalTag'

function DDPTag ({ item, accessor, icon, iconSize, trigger, className, style }) {
  const value = useMemo(() => {
    return accessor ? get(item, accessor) : item
  }, [item, accessor])

  const bindings = useMemo(() => {
    return { item }
  }, [item])

  return (
    <AbundanceViewPanelTrigger bindings={bindings} enabled={trigger}>
      <OpalTag value={value} className={className} style={style} icon={icon} iconSize={iconSize} />
    </AbundanceViewPanelTrigger>
  )
}

DDPTag.propTypes = {
  item: PropTypes.any,
  accessor: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  trigger: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
}

DDPTag.defaultProps = {
  trigger: false
}

export default DDPTag
